import { useEffect, useState } from "react";
import { Save, CreditCard } from "lucide-react";
import { toast } from "sonner";
import api, { fmtINR, errMsg } from "../../lib/api";
import { PageHeader, LoadingRows } from "../../components/Shared";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";

export default function RootPlans() {
  const [plans, setPlans] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/root/plans").then((r) => setPlans(r.data.plans)); }, []);
  if (!plans) return <LoadingRows rows={4} />;

  const setP = (i, k, v) => {
    const p = [...plans];
    p[i] = { ...p[i], [k]: k === "name" ? v : Number(v) || 0 };
    setPlans(p);
  };
  const save = async () => {
    setBusy(true);
    try { await api.put("/root/plans", { plans }); toast.success("Plans updated — they apply to super admin assignments immediately"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div data-testid="root-plans">
      <PageHeader title="Super Admin Plans" subtitle="Control how many partner accounts each super admin can create, and what they pay per month.">
        <Button data-testid="plans-save" onClick={save} disabled={busy} className="rounded-full font-bold active:scale-95 transition-transform">
          <Save className="h-4 w-4 mr-2" /> {busy ? "Saving…" : "Save Plans"}
        </Button>
      </PageHeader>
      <p className="text-sm text-muted-foreground mb-8 max-w-2xl">
        These plans price a Super Admin's platform access by partner-account allowance. Partner website billing
        (₹3,000 / ₹70 / ₹50) is completely separate and unchanged.
      </p>
      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-5 max-w-6xl">
        {plans.map((p, i) => (
          <div key={p.key} data-testid={`plan-${p.key}`} className="bg-card border border-border rounded-md p-6">
            <div className="flex items-center gap-2 mb-4">
              <CreditCard className="h-4 w-4 text-muted-foreground" />
              <span className="overline-label">{p.key}</span>
            </div>
            <div className="space-y-3">
              <label className="text-xs font-bold block">Plan name
                <Input data-testid={`plan-name-${p.key}`} value={p.name} onChange={(e) => setP(i, "name", e.target.value)} className="mt-1" /></label>
              <label className="text-xs font-bold block">Max partners
                <Input data-testid={`plan-max-${p.key}`} type="number" value={p.max_partners} onChange={(e) => setP(i, "max_partners", e.target.value)} className="mt-1" /></label>
              <label className="text-xs font-bold block">Price (₹/month)
                <Input data-testid={`plan-price-${p.key}`} type="number" value={p.price} onChange={(e) => setP(i, "price", e.target.value)} className="mt-1" /></label>
              <p className="text-xs text-muted-foreground pt-1">{p.max_partners} partners · {fmtINR(p.price)}/month</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
